import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import FeaturesSection, { PriceFormSection } from './components/FeaturesSection';
import RoomsSection from './components/RoomsSection';
import LocationSection from './components/LocationSection';
import BreakfastSection, { PoolSection } from './components/AmenitiesSection';
import GallerySection from './components/GallerySection';
import ReviewsSection, { FAQSection } from './components/ReviewsFAQSection';
import FooterSection from './components/FooterSection';
import FixedCTA from './components/FixedCTA';

export default function Home() {
  return (
    <div className="relative bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <PriceFormSection />
        <RoomsSection />
        <LocationSection />
        <BreakfastSection />
        <PoolSection />
        <GallerySection />
        <ReviewsSection />
        <FAQSection />
      </main>
      <FooterSection />
      <FixedCTA />
    </div>
  );
}